import { Download as DownloadIcon } from '@mui/icons-material'
import { Alert, Button, Stack } from '@mui/material'
import { useState } from 'react'
import type { FC } from 'react'

import Prompt from '@/components/UI/Prompt'

type Props = {
  handleDownload: () => Promise<void>
}

const DownloadCSV: FC<Props> = ({ handleDownload }) => {
  const [loading, setIsLoading] = useState<boolean>(false)
  const [isErrorDisplayed, setIsErrorDisplayed] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

  const onClick = async () => {
    setIsLoading(true)
    setErrorMessage(undefined)

    try {
      await handleDownload()
    } catch (e) {
      setIsErrorDisplayed(true)
      setErrorMessage('An unexpected error occurred.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => setIsErrorDisplayed(false)

  return (
    <>
      <Prompt open={isErrorDisplayed} onClose={handleClose}>
        <Alert severity="error">{errorMessage}</Alert>
        <Stack direction="row" justifyContent="end" mt="10px">
          <Button size="medium" variant="contained" onClick={handleClose}>
            Back
          </Button>
        </Stack>
      </Prompt>
      <Button
        name="downloadCsv"
        variant="contained"
        loading={loading}
        loadingPosition="end"
        endIcon={<DownloadIcon />}
        onClick={onClick}
      >
        Download CSV
      </Button>
    </>
  )
}

export default DownloadCSV
